import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Expand = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
      <Path d="M6.94 10.5a1 1 0 0 1 1 1v4.23h4.12a1 1 0 1 1 0 2H6.94a1 1 0 0 1-1-1V11.5a1 1 0 0 1 1-1ZM10.94 6.5a1 1 0 0 1 1-1h5.12a1 1 0 0 1 1 1v5.23a1 1 0 1 1-2 0V7.5h-4.12a1 1 0 0 1-1-1Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Expand
